import React from 'react';

interface GraphTooltipProps {
  visible: boolean;
  x: number;
  y: number;
  children: React.ReactNode;
}

export default function GraphTooltip({ visible, x, y, children }: GraphTooltipProps) {
  if (!visible) return null;
  return (
    <div
      className="fixed bg-popover text-popover-foreground border border-ctu-border px-3 py-2 rounded-md text-xs pointer-events-none z-[1001] whitespace-nowrap shadow-md max-w-[350px]"
      style={{ left: `${x}px`, top: `${y}px` }}
    >
      {children}
    </div>
  );
}
